import styled from 'styled-components';

export const Container = styled.div`
  .section-demo-hero--rate-content {
    display: flex;
    align-items: center;

    .section-demo-hero--rate-star {
      .StarPickerButton {
        line-height: 52px;
        cursor: default;

        &.halfStars:nth-child(2n + 1) {
          margin-left: 0px;
        }
        &.halfStars:nth-child(2n) {
          margin-right: 8px;
        }
      }
    }

    .section-demo-hero--rate-description {
      font-size: 18px;
      line-height: 42px;
      color: ${({ theme }) => (theme === 'light' ? '#ffffff' : 'var(--normal-title-color)')};
      margin: 0 0 0 18px;
    }
  }

  .section-demo-hero--rate-logo-content {
    display: flex;
    align-items: center;
    margin-top: 28px;
    width: 60%;
    .section-demo-hero--rate-logo-item {
      margin-right: 33px;
      width: 100%;
    }
  }

  @media (max-width: 768px) {
    .section-demo-hero--rate-content {
      display: flex;
      align-items: flex-start;
      flex-direction: column;

      p {
        margin: 0 !important;
      }
    }

    .section-demo-hero--rate-logo-content {
      width: 100%;
      margin: 10px 0 0 0;
    }
  }
`;
